import z from "zod";
import { zOrderPhotosTimeTypeSchema } from "./common";
export const zOrderPhotosSchemaDom = z.object({
    id: z.string(),
    imageUrls: z.string().array(),
    orderId: z.string(),
    timeType: zOrderPhotosTimeTypeSchema,
});
